import { render, staticRenderFns } from "./PeepsAlertRight.vue?vue&type=template&id=cc3fb48a&scoped=true&"
import script from "./PeepsAlertRight.vue?vue&type=script&lang=js&"
export * from "./PeepsAlertRight.vue?vue&type=script&lang=js&"
import style0 from "./PeepsAlertRight.vue?vue&type=style&index=0&id=cc3fb48a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3fb48a",
  null
  
)

export default component.exports